<template>
  <div>
    <section class="dialogsBox" v-show="!rejectIsShow && auditIsShow">
      <div>
        <h3>项目负责人审核</h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size:30px;color:#333" />
        </a>
        <ul v-if="details != ''">
          <li>
            <label>项目：</label>
            <p>{{ details.project_name }}</p>
          </li>
          <li>
            <label>结算类型：</label>
            <p v-if="details.type == 1">应收</p>
            <p v-else-if="details.type == 2">应付</p>
            <p v-else>未知</p>
          </li>
          <li>
            <label>费用名称：</label>
            <p>{{ details.name }}</p>
          </li>
          <li>
            <label>费用金额：</label>
            <p>{{ Number(details.amount) + "元" }}</p>
          </li>
          <li>
            <label>费用所属日期：</label>
            <p>
              {{
                details.finance_date != undefined
                  ? details.finance_date.substring(0, 10)
                  : ""
              }}
            </p>
          </li>
          <li>
            <label>提交人：</label>
            <p>{{ details.create_user_name }}</p>
          </li>
        </ul>
        <div>
          <a-button type="danger" @click="auditReject">驳回</a-button>
          <a-button type="primary" @click="auditPass">同意</a-button>
        </div>
      </div>
    </section>

    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width:300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectCancel">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      auditIsShow: true,
      reason: "",
      rejectIsShow: false,
      details: {}
    };
  },
  props: {
    auditManagerDetails: {}
  },
  watch: {
    auditManagerDetails() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.auditManagerDetails != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.auditManagerDetails;
      console.log(this.details);
    },
    auditReject() {
      this.rejectIsShow = true;
    },
    auditPass() {
      this.auditIsShow = false;
      this.auditPassHttp();
      // let _this = this;
      // this.$confirm({
      //   title: "提示",
      //   cancelText: "取消",
      //   okText: "确认",
      //   content: "请确定该笔费用是否审核通过",
      //   onOk() {
      //     _this.auditPassHttp();
      //   },
      //   onCancel() {
      //     _this.auditIsShow = true;
      //     _this.$emit("hideInDialogManager", false);
      //   }
      // });
    },
    auditPassHttp() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "finance/projectCheckPass";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        id: this.details.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$emit("hideInDialogManager", true);
          this.$message.success("费用已审核通过");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    rejectCancel() {
      this.$emit("hideInDialogManager", false);
    },
    rejectSure() {
      if (this.reason != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.finance +
          "finance/projectCheckReject";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          reason: this.reason,
          id: this.details.id
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("申请已驳回");
            this.reason = "";
            this.rejectIsShow = false;
            this.$emit("hideInDialogManager", true);
          } else {
            this.rejectIsShow = false;
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请输入驳回原因！");
      }
    }
  }
};
</script>
